import { useTheme, Stack } from "@carrotfertility/carotene-core"
import { QuickLinks } from "../../home/quick-links/QuickLinks"
import React from "react"
import { CarrotPlansCheckInModule } from "#/components/home/carrot-plan/CarrotPlansCheckInModule"
import CarrotPlanHero from "#/components/home/carrot-plan/CarrotPlansHero"
import QualtricsIntercept from "#/components/views/home/QualtricsIntercept"
import { useGetCarrotPlanRequestStatus } from "#/components/carrot-plans/hooks/useCarrotPlanRequestStatus"
import useCarrotPlan from "#/components/carrot-plans/hooks/useCarrotPlan"
import useCarrotPlanEmployeeSettings from "#/components/carrot-plans/hooks/useCarrotPlanEmployeeSettings"
import { Hero } from "#/components/home/Hero"
import { useIsMemberInSensitiveState } from "#/components/carrot-plans/hooks/useIsMemberInSensitiveState"
import { SensitiveStateHomeMain } from "#/components/views/home/SensitiveStateHomeMain"
import { useFlags } from "launchdarkly-react-client-sdk"

export const HomeMain = (): JSX.Element => {
  const theme = useTheme()
  const carrotPlanQuery = useCarrotPlan()
  const carrotPlanEmployeeSettingsQuery = useCarrotPlanEmployeeSettings()
  const cpRequestStatusQuery = useGetCarrotPlanRequestStatus()
  const isMemberInSensitiveState = useIsMemberInSensitiveState()
  const { airwallexBenefitChampion } = useFlags()

  const shouldShowBenefitHighlightsHero =
    !carrotPlanQuery.hasCarrotPlan ||
    carrotPlanEmployeeSettingsQuery.isDoneForNow ||
    cpRequestStatusQuery.data?.isPendingPostDoneForNowPlan
  const shouldShowHero = shouldShowBenefitHighlightsHero || airwallexBenefitChampion
  const shouldShowCarrotPlanHero = !shouldShowBenefitHighlightsHero && carrotPlanQuery.data

  const areAnyLoading =
    carrotPlanQuery.isLoading || carrotPlanEmployeeSettingsQuery.isLoading || cpRequestStatusQuery.isLoading

  if (areAnyLoading) {
    return null
  }

  if (isMemberInSensitiveState) {
    return <SensitiveStateHomeMain />
  }

  return (
    <Stack spacing={theme.spacing(theme.tokens.spacing.lg)}>
      <CarrotPlansCheckInModule />
      {shouldShowHero && <Hero carrotPlanIsOnTheWay={cpRequestStatusQuery.data?.carrotPlanIsOnTheWay} />}
      <Stack spacing={theme.spacing(theme.tokens.spacing.xxxl)}>
        {shouldShowCarrotPlanHero && <CarrotPlanHero plan={carrotPlanQuery.data} />}
        <QualtricsIntercept />
      </Stack>
      <QuickLinks />
    </Stack>
  )
}
